export default __webpack_public_path__ + "static/media/Tunic of the Still Pond.7d51dc43.jpg";